export const NAV_LINKS = [
  { label: "Home", to: "/" },
  { label: "About", to: "/about" },
  { label: "Why Choose Us", to: "/why-choose-us" },
  { label: "Blog", to: "/blog" },
  { label: "Careers", to: "/careers" },
  { label: "Contact", to: "/contact" },
];

export const LEGAL_LINKS = [
  { label: "Privacy Policy", to: "/privacy" },
  { label: "Terms & Conditions", to: "/terms" },
  { label: "Disclaimer", to: "/disclaimer" },
];

export const ROUTE_SEO = {
  "/": {
    title: "Crescet Edustreams — One Ecosystem for Every Student Journey",
    description: "Crescet Edustreams is a DPIIT-recognized EdTech ecosystem uniting AdmissionsNest, CounselNest, and TutorsNest with AskPurple AI study buddy. Trusted educational guidance across India and globally.",
    canonical: "https://crescetedustreams.com/",
  },
  "/about": {
    title: "About Us — Crescet Edustreams | DPIIT Recognized EdTech Platform",
    description: "Learn about Crescet Edustreams' mission, leadership, and ISO 9001:2015 certified ecosystem connecting student admissions, career counselling, and private tutoring.",
    canonical: "https://crescetedustreams.com/about",
  },
  "/why-choose-us": {
    title: "Why Choose Us — Crescet Edustreams | Scientific Guidance & AI",
    description: "Discover how Crescet Edustreams delivers integrated guidance through scientific psychometric assessments, expert counsellors, verified tutors, and AskPurple AI.",
    canonical: "https://crescetedustreams.com/why-choose-us",
  },
  "/blog": {
    title: "Education & Career Blog — Crescet Edustreams",
    description: "Expert guides and insights on college admissions, overseas applications, stream selection after Class 10, DMIT testing, and tutoring strategies.",
    canonical: "https://crescetedustreams.com/blog",
  },
  "/careers": {
    title: "Careers & Open Roles — Join Crescet Edustreams",
    description: "Explore career opportunities at Crescet Edustreams. Join our mission to revolutionize student guidance across India and international education markets.",
    canonical: "https://crescetedustreams.com/careers",
  },
  "/contact": {
    title: "Contact Us — Crescet Edustreams | Admissions, Counselling & Tutoring",
    description: "Get in touch with Crescet Edustreams advisors for college admissions, career counselling, psychometric testing, private tutoring, or institutional partnerships.",
    canonical: "https://crescetedustreams.com/contact",
  },
  "/askpurple": {
    title: "AskPurple AI — Your 24/7 Educational Study Companion & Guide",
    description: "AskPurple is the unified AI student companion powering Crescet Edustreams. Instant answers for admissions, career dilemmas, homework concepts, and study roadmaps.",
    canonical: "https://crescetedustreams.com/askpurple",
  },
  "/privacy": {
    title: "Privacy Policy — Crescet Edustreams",
    description: "Our comprehensive privacy policy detailing how Crescet Edustreams collects, protects, and handles student and user data in compliance with data laws.",
    canonical: "https://crescetedustreams.com/privacy",
  },
  "/terms": {
    title: "Terms & Conditions — Crescet Edustreams",
    description: "Official terms and conditions for using Crescet Edustreams, AdmissionsNest, CounselNest, TutorsNest, and AskPurple services.",
    canonical: "https://crescetedustreams.com/terms",
  },
  "/disclaimer": {
    title: "Disclaimer — Crescet Edustreams",
    description: "Important institutional and legal disclaimers regarding educational advisory, admissions recommendations, and assessment outcomes.",
    canonical: "https://crescetedustreams.com/disclaimer",
  },
};

export const ROUTE_TITLES = Object.fromEntries(
  Object.entries(ROUTE_SEO).map(([path, data]) => [path, data.title])
);

export function getSeoForPath(pathname) {
  if (ROUTE_SEO[pathname]) return ROUTE_SEO[pathname];
  if (pathname.startsWith("/blog/")) {
    return {
      title: "Article · Crescet Edustreams Blog",
      description: "Read in-depth educational guidance, admissions strategies, and career frameworks on Crescet Edustreams.",
      canonical: `https://crescetedustreams.com${pathname}`,
    };
  }
  return ROUTE_SEO["/"];
}

export function getTitleForPath(pathname) {
  return getSeoForPath(pathname).title;
}

